import shave from "shave";
import gsap from "gsap";

function updatePressArticleScrollFades(scrollEl) {
  const outer = scrollEl.closest(".press-article__lightbox-body");
  if (!outer) {
    return;
  }
  const { scrollTop, scrollHeight, clientHeight } = scrollEl;
  const epsilon = 2;
  outer.classList.toggle("has-scroll-fade-top", scrollTop > epsilon);
  outer.classList.toggle(
    "has-scroll-fade-bottom",
    scrollTop + clientHeight < scrollHeight - epsilon
  );
}

function bindPressArticleLightboxScrollFades(article) {
  const scroll = article.querySelector(".press-article__lightbox-body-scroll");
  if (!scroll) {
    return;
  }
  const onScrollOrResize = () => {
    updatePressArticleScrollFades(scroll);
  };
  scroll.addEventListener("scroll", onScrollOrResize, { passive: true });
  window.addEventListener("resize", onScrollOrResize);
  onScrollOrResize();
}

export default {
  init() {
    function applyShave() {
      const elements = document.querySelectorAll(".press-article__body");
      for (const element of elements) {
        const text = element.querySelector("div");
        shave(text, element.clientHeight);
      }
    }

    const trigger = document.querySelector(".book-full__reviews-trigger");
    if (trigger) {
      trigger.addEventListener("click", applyShave);
    }

    applyShave();
    setTimeout(applyShave, 100);
    window.addEventListener("resize", applyShave);

    const articles = document.querySelectorAll(".press-article");

    for (const article of articles) {
      const overlay = article.querySelector(".press-article__lightbox-overlay");
      const lightbox = article.querySelector(".press-article__lightbox");
      const inner = article.querySelector(".press-article__lightbox-inner");
      const open = article.querySelector(".press-article__open");
      if (!open) {
        continue;
      }

      bindPressArticleLightboxScrollFades(article);

      open.addEventListener("click", () => {
        overlay.style.display = "block";

        gsap.to(overlay, {
          duration: 0.2,
          opacity: 1,
          ease: "power2.inOut",
        });

        gsap.fromTo(
          lightbox,
          { opacity: 0, scale: 0.95 },
          {
            duration: 0.2,
            opacity: 1,
            scale: 1,
            ease: "power2.inOut",
          }
        );

        inner.style.pointerEvents = "auto";

        const scrollBody = article.querySelector(
          ".press-article__lightbox-body-scroll"
        );
        if (scrollBody) {
          window.requestAnimationFrame(() => {
            updatePressArticleScrollFades(scrollBody);
            window.setTimeout(() => {
              updatePressArticleScrollFades(scrollBody);
            }, 150);
          });
        }

        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        overlay.style.pointerEvents = "auto";
      });

      overlay.addEventListener("click", () => {
        gsap.to(overlay, {
          duration: 0.2,
          opacity: 0,
          ease: "power2.inOut",
          onComplete: () => {
            overlay.style.display = "none";
            overlay.style.pointerEvents = "none";
          },
        });

        gsap.to(lightbox, {
          duration: 0.2,
          opacity: 0,
          scale: 0.95,
          ease: "power2.inOut",
        });

        inner.style.pointerEvents = "none";
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      });
    }
  },
};
